// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    SetFormErrors,
    SetIsBillingAddressUpdateRequired,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/ValidateBillingAddressForm";

const XngValidateOnly: typeof SetFormErrors = (props: any) => {
    if ((props.parameter as any).updateErrorOnly) {
        props.parameter.onSuccess?.(Object.keys(props.formErrors).length === 0);
        return false;
    }
};

export const SetIsShippingAddressUpdateRequired: typeof SetIsBillingAddressUpdateRequired = props => {
    const isBillingAddressTheSameAsShipping = props.getState().pages.onePageCheckout.isBillingAddressTheSameAsShipping;
    if (isBillingAddressTheSameAsShipping) {
        const isBillingAddressValid = Object.keys(props.formErrors).length === 0;
        props.dispatch({
            type: "Pages/OnePageCheckout/SetIsShippingAddressUpdateRequired",
            isShippingAddressUpdateRequired: !isBillingAddressValid,
        });
    }
};

addToChainAfter(chain, SetFormErrors, XngValidateOnly);
addToChainAfter(chain, SetIsBillingAddressUpdateRequired, SetIsShippingAddressUpdateRequired);
